import React from "react";
import { Grid, TextField, InputAdornment } from "@mui/material";
import { LockIcon } from "../../assets/icons";

const NewPassword = (props) => {
  const { formData, handleChange, passwordError } = props;

  return (
    <>
      <Grid item xs={12} md={5}>
        <TextField
          fullWidth
          name="newPassword"
          placeholder="New Password"
          value={formData.newPassword}
          onChange={handleChange}
          error={!!passwordError.newPassword}
          helperText={passwordError.newPassword}
          sx={{
            boxSizing: "border-box",
            borderRadius: "10px",
            backgroundColor: "#fff",
            borderColor: "#C0C0C0",
            borderWidth: "5px",
            "& .MuiOutlinedInput-root": {
              height: "46px",
              borderColor: "#C0C0C0",
              backgroundColor: "none",
              "&:hover fieldset": {
                borderColor: "#C0C0C0",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#C0C0C0",
              },
            },
            "& .MuiFormHelperText-root": {
              color: "#FF6666",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
            sx: {
              borderRadius: "10px",
              height: 45,
              fontSize: "16px",
              fontWeight: "400",
            },
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TextField
          fullWidth
          name="confirmNewPassword"
          placeholder="Confirm New Password"
          value={formData.confirmNewPassword}
          onChange={handleChange}
          error={!!passwordError.confirmNewPassword}
          helperText={passwordError.confirmNewPassword}
          sx={{
            boxSizing: "border-box",
            borderRadius: "10px",
            backgroundColor: "#fff",
            borderColor: "#C0C0C0",
            borderWidth: "5px",
            "& .MuiOutlinedInput-root": {
              height: "46px",
              borderColor: "#C0C0C0",
              backgroundColor: "none",
              "&:hover fieldset": {
                borderColor: "#C0C0C0",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#C0C0C0",
              },
            },
            "& .MuiFormHelperText-root": {
              color: "#FF6666",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
            sx: {
              borderRadius: "10px",
              height: 45,
              fontSize: "16px",
              fontWeight: "400",
            },
          }}
        />
      </Grid>
    </>
  );
};

export default NewPassword;
